export const config = {
	newsApiKey: process.env.REACT_APP_NEWS_API_KEY,
	newsCatcherKey: process.env.REACT_APP_NEWSCATCHER_API_KEY,
	bestApiKey: process.env.REACT_APP_BEST_SHEET_API_KEY,
	base_url: process.env.REACT_APP_SWAGGER_BASE_URL,
};
